export default "__VITE_ASSET__BI6dlGW0__"